import { SiteInformationApi } from "@socotec.io/ssp-back-sdk";
import { sspProjectConfig } from "@/setup/openApiConfig";

export const siteInformationApi = new SiteInformationApi(sspProjectConfig);

/**
 * Wrapper kept for the get-or-create semantics the site-information screen
 * relies on: the backend action 404s when the sheet does not exist yet, and the
 * screen expects one to be created transparently.
 */
export const siteInformationClient = {
  getSiteInformationWithPlans: async (projectId) => {
    try {
      return await siteInformationApi.withPlans({ projectId });
    } catch (error) {
      if (error?.response?.status === 404) {
        return await siteInformationApi.create({
          siteInformationRequest: { project: projectId },
        });
      }
      throw error;
    }
  },

  create: (siteInformationData) =>
    siteInformationApi.create({ siteInformationRequest: siteInformationData }),

  partialUpdate: ({ uuid, ...data }) => {
    if (!uuid) {
      throw new Error("UUID is required for partial update");
    }
    return siteInformationApi.partialUpdate({
      uuid,
      patchedSiteInformationRequest: data,
    });
  },
};
